import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpErrorResponse
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import {
    Observable,
    of,
    throwError
} from 'rxjs';
import {
    first,
    mergeMap,
    catchError,
    map,
    finalize
} from 'rxjs/operators';
import { Router } from '@angular/router';
import { LoaderService } from '../../service/loader/loader.service';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
    /**
     * Constructor.
     */
    constructor(private loaderService: LoaderService) {
    }

    /**
     * Intercepts all HTTP requests and adds the JWT token to the request's header if the URL
     * is a REST endpoint and not login or logout.
     */
    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.loaderService.show();
        return next.handle(request).pipe(
            finalize(() => this.loaderService.hide())
        );
    }
}

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private router: Router, private loaderService: LoaderService){
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((fault: HttpErrorResponse) => {
                this.loaderService.hide();

                return throwError(fault);
            })
        );
      }
}
